import Alpine from "alpinejs";

Alpine.data("brandsListing", () => {
    return {
        brandsSelector: ".cars__list .cars__list-item",
        toggleSelector: ".cars__nav .cars__nav-link",

        showPopular() {
            const parent = this.$el.closest("section.cars");

            parent.querySelector("#show-popular").classList.add("active");
            parent.querySelector("#show-all").classList.remove("active");

            this.toggle("[data-popular='1']");
        },

        showAll() {
            const parent = this.$el.closest("section.cars");

            parent.querySelector("#show-popular").classList.remove("active");
            parent.querySelector("#show-all").classList.add("active");

            this.toggle(false);
        },

        toggle(matcher) {
            const parent = this.$el.closest("section.cars"),
                elements = parent.querySelectorAll(this.brandsSelector);

            for (const element of elements) {
                element.hidden = matcher && !element.matches(matcher);
            }
        }
    };
});
